export const BASELINE_COURSE = 'baseline';
export const MICROLEARNING_COURSE = 'microlearning';
